module.exports = require("passport-local");